export const CommonNonRecoverableErrorsCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Gestione errori non recuperabili',
    path: '/sistema/eventmanager/gestione-errori-non-recuperabili',
  },
];
